<template>
    <div class="room_component">
        <el-drawer title="房间配置" :visible.sync="isShow" size="900px" @close="$emit('close')">
            <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
                label-width="70px">
                <el-form-item label="房型名称" prop="roomTypeName">
                    <el-input v-model="searchForm.roomTypeName" placeholder="房型名称" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item label="房间号" prop="roomNo">
                    <el-input v-model="searchForm.roomNo" placeholder="房间号" style="width: 230px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                    <el-button @click="handleReset" size="small">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="padding-bottom: 10px">
                <el-button icon="el-icon-plus" type="primary" size="small" @click="handleAdd">添加</el-button>
                <el-button type="success" size="small" @click="handleShowFloor">楼层</el-button>
            </div>

            <el-table border size="small" style="width: 100%; margin-top: 10px" :data="tableData" v-loading="isLoading"
                element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-table-column type="index" label="排序" align="center"></el-table-column>
                <el-table-column prop="roomTypeName" label="房间类型">
                    <template slot-scope="{ row }">
                        <el-tag size="mini">{{ row.roomTypeName }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="floor" label="楼层"></el-table-column>
                <el-table-column prop="roomNo" label="房间号"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="{ row }">
                        <el-tag type="danger" size="mini" v-if="row.status == 3">{{ row.statusDesc }}</el-tag>
                        <el-tag type="success" size="mini" v-else>{{ row.statusDesc }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="120">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleEdit(row)" v-if="row.status != 1">编辑</el-button>
                        <el-button size="mini" type="text" style="color: red" @click="handleDelete(row)" v-if="row.status != 1">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
                style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
                :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-drawer>

        <el-dialog :visible.sync="isAdd" :title="!modelForm.id ? '添加' : '编辑'" width="500px" append-to-body destroy-on-close
            :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="modelForm" :model="modelForm" inline label-width="110px" style="margin: 0 20px" size="small" :rules="modelFormRules">
                <el-form-item label="房间类型" prop="roomTypeId">
                    <el-select v-model="modelForm.roomTypeId" placeholder="请选择房间类型" clearable style="width: 250px">
                        <el-option v-for="item in roomTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="楼层" prop="floor">
                    <el-select v-model="modelForm.floor" placeholder="请选择楼层" clearable style="width: 250px">
                        <el-option v-for="item in floorList" :key="item.id" :label="item.floorName" :value="item.floorName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="房间号" prop="roomNo">
                    <el-input type="text" v-model="modelForm.roomNo" placeholder="请输入房间号" style="width: 250px"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="modelForm.status" style="width: 250px">
                        <el-radio :label="0">启用</el-radio>
                        <el-radio :label="3">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- <el-form-item label="预定说明" prop="name">
                    <el-input type="textarea" v-model="modelForm.name" placeholder="请输入房型名称" style="width: 250px"></el-input>
                </el-form-item> -->
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isAdd = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit('modelForm')">提交</el-button>
            </div>
        </el-dialog>

        <!-- 楼层 -->
        <el-dialog :visible.sync="isFloor" title="楼层" width="530px" append-to-body destroy-on-close :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form ref="floorForm" :model="floorForm" label-width="80px" style="margin: 0 20px" size="small" :rules="modelFormRules">
                <el-form-item label="楼层" :prop="'list.'+key+'.floorName'" v-for="(item,key) in floorForm.list" :key="key" :rules="modelFormRules.floorName">
                    <el-input type="text" v-model="item.floorName" placeholder="请输入楼层" style="width: 250px;margin-right: 5px;"></el-input>
                    <el-button type="primary" @click="handleAddFloor" size="small" v-if="key == 0">添加</el-button>
                    <el-button type="danger" @click="handleDelFloor(key)" size="small" v-else>删除</el-button>
                </el-form-item>
            </el-form>
            <div class="footer" style="margin: 0 20px; text-align: right">
                <el-button type="text" @click="isFloor = false">取消</el-button>
                <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmitFloor('floorForm')">提交</el-button>
            </div>
        </el-dialog>
   </div>
</template>


<script>
import _ from "lodash";
export default {
    props: {
        isRoom: {
            type: Boolean,
            default: false,
        },
        hotelId: {
            type: String,
            default: null,
        },
    },
    data() {
        
        return {
            isShow: false,
            searchForm: {
                roomTypeName: "",
                roomNo: "",
                hotelId: this.hotelId,
                pageNumber: 1,
                pageSize: 10,
            },
            isLoading: false,
            tableData: [],
            total: 0,

            isAdd: false,
            modelForm: {
                roomTypeId: "",
                floor: "",
                roomNo: "",
                status: 0
            },
            modelFormRules: {
                roomTypeId: [{ required: true, message: "请选择房型", trigger: "blur" }],
                floor: [{ required: true, message: "请选择楼层", trigger: "blur" }],
                roomNo: [{ required: true, message: "请输入房间号", trigger: "blur" }],
                floorName: [{ required: true, message: "请输入楼层名称", trigger: "blur" }],
            },
            submitLoading: false,

            isFloor: false,
            roomTypeList: [],
            floorList: [],
            floorForm: {
               floorList: [], 
            },
        }
    },
    watch: {
        isRoom(newVal) {
            this.isShow = !!newVal;
            if (!!newVal) {
                this.searchForm = {
                    roomTypeName: "",
                    roomNo: "",
                    hotelId: this.hotelId,
                    pageNumber: 1,
                    pageSize: 10,
                };

                this.getRoomList();
                this.getFloorList();
                this.getRoomTypeList();
            }
        },
    },
    methods: {
        handleSubmitFloor(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    this.postRequest("/floor/saveFloorVo", this.floorForm)
                    .then((res) => {
                        this.submitLoading = false;
                        let data = res.data;
                        if (data.code == 200) {
                            this.$message.success(data.msg);
                            this.isFloor = false;
                            this.getFloorList();
                        }
                    })
                    .catch(() => {
                        this.submitLoading = false;
                    });
                }
            })
        },
        handleDelFloor(key) {
            this.floorForm.list.splice(key, 1);
        },
        handleAddFloor() {
            this.floorForm.list.push({ floorName: "" });
        },
        handleShowFloor() {
            this.floorForm = {
                hotelId: this.hotelId,
                list: this.floorList.length ? _.cloneDeep(this.floorList) : [{ floorName: "" }]
            }
            this.isFloor = true;
        },
        handleSubmit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitLoading = true;
                    if (!this.modelForm.id) {
                        this.postRequest("/api/room/add", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getRoomList();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    } else {
                        this.postRequest("/api/room/modify", this.modelForm)
                            .then((res) => {
                                this.submitLoading = false;
                                let data = res.data;
                                if (data.code == 200) {
                                    this.$message.success(data.msg);
                                    this.isAdd = false;
                                    this.getRoomList();
                                }
                            })
                            .catch(() => {
                                this.submitLoading = false;
                            });
                    }
                }
            });
        },
        handleAdd() {
            this.modelForm = {
                hotelId: this.hotelId,
                name: "",
                shortName: "",
                maxLoad: "",
                roomArea: "",
                status: 0,
                chargingMode: 0,
                defaultPrice: "",
                showPrice: "",
                weekendPrice: "",
                roomPictureUrl: [],
                haveWindow: 1,
                haveBreakfast: 1,
                haveSmoke: 0,
                extraBed: 0,
                rushroomSupporting: [],
                amenities: [],
                media: [],
                bath: [],
            };
            this.isAdd = true;
        },
        handleEdit(row) {
            this.getRequest(`/api/room/get/${row.id}`).then((res) => {
                let data = res.data;
                if (data.code == 200) {
                    this.modelForm = data.data;
                    this.isAdd = true;
                }
            });
        },
        handleDelete(item) {
            this.$confirm("确定将选择数据删除?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.getRequest(`/api/room/delete/${item.id}`).then((res) => {
                    let data = res.data;
                    if (data.code == 200) {
                        this.$message.success("删除成功");
                        this.getRoomList();
                    }
                });
            });
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getRoomList();
        },

        handleReset() {
            this.searchForm = {
                hotelId: this.hotelId,
                name: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.getRoomList();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getRoomList();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getRoomList();
        },
        getRoomList() {
            this.isLoading = true;
            this.getRequest("/api/room/page", this.searchForm).then((res) => {
                let data = res.data;
                this.isLoading = false;
                if (data.code == 200) {
                    this.tableData = data.data.records;
                    this.total = data.data.total;
                }
            });
        },
        getFloorList() {
            this.getRequest(`/floor/getHotelFloor?hotelId=${this.hotelId}`)
            .then(res => {
                let data = res.data;
                if(data.code == 200) {
                    this.floorList = data.data;
                }
            })
        },
        getRoomTypeList() {
            this.getRequest(`/api/roomType/getByHotelId?hotelId=${this.hotelId}`)
            .then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.roomTypeList = data.data;
                }
            })
        }
    },
}
</script>